module.exports = __webpack_public_path__ + "media/images/keeplist_ic-2f156e5300a6e90d5d8d18457cbf5125.svg";